import React from 'react';
const Footer = () => <footer className="workspace-footer"><span>Sender Tech · Thermoking</span><span>Sua operação, sempre por perto.</span></footer>;
export default Footer;
